import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { RouterLinkProps } from 'vue-router';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { NOT_FOUND } from '@/modules/main-screen/constants';
import { SETTINGS_NOT_FOUND } from '@/entities/staged/settings';


export default /*@__PURE__*/_defineComponent({
  __name: 'maybe-router-link',
  props: {
    to: {},
    custom: { type: Boolean }
  },
  setup(__props: any) {

// Компонент используется пока у нас не SPA, для более бесшовных переходов, если это возможно


const router = useRouter();

const isResolved = computed(() => {
  if (!router) {
    return false;
  }
  const route = router.resolve(__props.to);
  if (route.name === SETTINGS_NOT_FOUND || route.name === NOT_FOUND) {
    return false;
  }

  return !!route.matched.length;
});

const computedComponent = computed(() => {
  return isResolved.value ? 'router-link' : 'a';
});
const params = computed(() => {
  if (isResolved.value) {
    return {
      to: __props.to
    };
  }
  return {
    href: __props.to
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(computedComponent.value), _normalizeProps(_guardReactiveProps(params.value)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})